import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { GetMediumListService } from './api-services/get-medium-list-service';
import { GetBuyerCrossGoodsSetListService } from './api-services/get-buyer-cross-goods-set-list.service';
import { UpdateBuyerCrossGoodsSetMasterListService } from './api-services/update-buyer-cross-goods-set-master-list.service';
import { KYMW4800Component } from './kymw4800.component';
import { KYMW4801Module } from '../kymw4801/kymw4801.module';

/**
 * クロス商品設定マスタ管理画面 モジュール設定クラス
 *
 * @export KYMW4800Module
 * @class KYMW4800Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
    KYMW4801Module,
  ],
  declarations: [KYMW4800Component],
  providers: [
    GetMediumListService,
    GetBuyerCrossGoodsSetListService,
    UpdateBuyerCrossGoodsSetMasterListService,
  ],
})
export class KYMW4800Module { }
